import Image from "@p-ban/common/src/components/html/Image"
import loginImage1 from "@/../public/images/login_image_1.jpg"
import loginImage2 from "@/../public/images/login_image_2.jpg"
import loginImage3 from "@/../public/images/login_image_3.jpg"
import loginPageLogo from "@/../public/icons/pban_logo.png"

export const LoginImage = () => {
  return (
    <div className="h-[568px] w-[368px] rounded-l-[12px] bg-[#ffffff]">
      <div className="relative h-[568px] w-[368px] overflow-hidden rounded-[12px]">
        <Image
          alt=""
          src={loginImage1}
          className="animate-login-bounce1 pointer-events-none absolute left-0 top-0 h-full w-full rounded-[12px] object-cover opacity-0"
        />
        <Image
          alt=""
          src={loginImage2}
          className="animate-login-bounce2 pointer-events-none absolute left-0 top-0 h-full w-full rounded-[12px] object-cover opacity-0"
        />
        <Image
          alt=""
          src={loginImage3}
          className="animate-login-bounce3 pointer-events-none absolute left-0 top-0 h-full w-full rounded-[12px] object-cover opacity-0"
        />
        <div className="pointer-events-none absolute bottom-0 left-0 flex h-[280px] w-full flex-col justify-end rounded-b-[12px] bg-gradient-to-b from-transparent to-[#00000099]">
          <Image
            className="pointer-events-auto z-[1] m-4 object-cover"
            alt="株式会社ピーバンドットコム"
            src={loginPageLogo}
            width={100}
            height={100}
          />
        </div>
      </div>
    </div>
  )
}
